app.service('activeElement', function (console, html) {
	var element = null;
	function set(el) {
		if (html.has('show-loading')) {
			console.log('Pomijamy zapisanie elementu z uwagi na aktywny focus-loading', el);
			return;
		}
		if (el) {
			element = el;
			
		} else if (document.activeElement !== null &&
			document.activeElement !== document.body &&
			document.activeElement !== document.documentElement) {
			element = document.activeElement;
		} else {
			element = null;
		}
		console.log('Zapisanie aktywnego elementu', element);
	}
	function get() {
		return element;
	}
	function focus() {
		let element = get();
		if(element){
			element.focus();
			console.log('Powrót na ostatni zapisany element, jako aktywny', element);
		} else {
			console.log('Brak ostatniego aktywnego elementu do focusowania po powrocie');
		}
	}

	return {
		set,
		get,
		focus
	};
});
